import { useAuth } from "@clerk/clerk-react";
import {
  Backdrop,
  CircularProgress,
  Grid,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import pic from "assets/pitchplease/pic.png";
import { OrganizationUserContext } from "contexts/Organization";
import { SplashPage, SubscriptionContext } from "contexts/Subscription";
import { useContext, useEffect } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router";
import { AddOnItemName } from "schemas/dashboard";
import { Plans } from "schemas/payments";
import { routes } from "schemas/routes";

import { PAGE_VISITED } from "constants/trackingProps";
import { AuthAction } from "features/Auth/schema";
import { getParams, getSource, trackEvent } from "utils/tracking";
import { useLogin } from "utils/useLogin";
import { useSubscription } from "utils/useSubscription";

import PitchPleaseAuth from "./Auth";
import ProgramInfo from "./ProgramInfo";
import { LIGHT_YELLOW } from "./styles";

const PitchPlease = () => {
  const location = useLocation();
  const isSignedIn = getParams("signed_in") === "true";
  const navigate = useNavigate();
  const source = getSource();

  const { isLoaded } = useAuth();
  const { fetchUserInfo, fetchUserLoading } = useLogin();

  const { currentOrg } = useContext(OrganizationUserContext);
  const { subscription } = useContext(SubscriptionContext);
  const { handleCheckout } = useSubscription();

  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down("md"));
  const successCheckout = getParams("checkout") === "success";

  const checkoutUgcBundle = async () => {
    if (currentOrg?.isVaUser) {
      handleCheckout(
        AddOnItemName.oui_studio,
        source || "",
        window.location.pathname,
        SplashPage.ooo,
      );
    } else {
      handleCheckout(
        Plans.VA_YEARLY,
        source || "",
        window.location.pathname,
        SplashPage.ooo,
      );
    }
  };

  useEffect(() => {
    trackEvent(PAGE_VISITED);
    if (!currentOrg?.id) {
      fetchUserInfo();
    } else if (isSignedIn && currentOrg?.id) {
      checkoutUgcBundle();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSignedIn, currentOrg?.id, subscription?.subscription?.planName]);

  useEffect(() => {
    if (successCheckout) {
      navigate(`/${routes.dashboard}${location.search}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [successCheckout]);

  return fetchUserLoading || !isLoaded ? (
    <Backdrop
      sx={{
        backgroundColor: LIGHT_YELLOW,
        zIndex: 9999,
        position: "absolute",
      }}
      open={fetchUserLoading}
      appear={false}
    >
      <CircularProgress />
    </Backdrop>
  ) : (
    <Grid
      container
      sx={{
        backgroundColor: LIGHT_YELLOW,
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        overflowY: "auto",
      }}
    >
      {!isMobileScreen && (
        <Grid
          item
          xs={5}
          lg={6}
          sx={{
            backgroundImage: `url(${pic})`,
            backgroundSize: "cover",
            backgroundPosition: "bottom",
          }}
        ></Grid>
      )}

      <Grid
        item
        xs
        md
        lg
        container
        justifyContent={"center"}
        alignItems={"center"}
      >
        <Routes>
          <Route
            path="/"
            element={
              <ProgramInfo
                checkoutUgcBundle={checkoutUgcBundle}
                fetchUserLoading={fetchUserLoading}
              />
            }
          />
          <Route
            path="/sign-in/*"
            element={<PitchPleaseAuth action={AuthAction.SIGN_IN} />}
          />
          <Route
            path="/sign-up/*"
            element={<PitchPleaseAuth action={AuthAction.SIGN_UP} />}
          />
        </Routes>
      </Grid>
    </Grid>
  );
};

export default PitchPlease;
